import React, { FunctionComponent } from "react"
import { Button, CircularProgress, Fade, Modal, Typography } from "@material-ui/core"
import styles from "./DoneModal.module.scss"
import { useBatchPageContext } from "../useBatchPageContext"
import { useStepControlsContext } from "../../../features/StepControls/useStepControlsContext"
import { LoadingButton } from "../../../components/LoadingButton"

export interface DoneModalProps {
    show: boolean
    loading?: boolean
}

export const DoneModal: FunctionComponent<DoneModalProps> = ({ show, loading = false }) => {
    const { resetPage } = useBatchPageContext()
    const { reset } = useStepControlsContext()
    function handleDone() {
        resetPage()
        reset()
    }
    return (
        <>
            <Modal
                open={show}
                closeAfterTransition={!show}
                className={styles.DoneModal__modal}
                data-testid="done-modal"
            >
                <Fade in={show}>
                    <div className={styles.DoneModal__modalcard}>
                        <div className={styles.DoneModal__contents}>
                            <Typography className={styles.DoneModal__desc}>
                                You've approved your new audio and your files are now being
                                generated. When they are done, they will begin downloading
                                automatically.
                            </Typography>
                            <LoadingButton
                                buttonId={"done-btn"}
                                disabled={loading}
                                loading={loading}
                                text={"Done"}
                                onClick={handleDone}
                            />
                        </div>
                    </div>
                </Fade>
            </Modal>
        </>
    )
}
